import React from "react";
import { Footer } from "@excalidraw/excalidraw/index";
import { useI18n } from "@excalidraw/excalidraw/i18n";
import { workspaceText } from "@excalidraw/excalidraw/components/workspaceText";

import { DebugFooter, isVisualDebuggerEnabled } from "./DebugCanvas";

export const AppFooter = React.memo(
  ({ onChange }: { onChange: () => void }) => {
    const { langCode } = useI18n();
    return (
      <Footer>
        <span className="studio-storage">
          <span aria-hidden="true" />
          {workspaceText(langCode, "local")}
        </span>
        {isVisualDebuggerEnabled() && <DebugFooter onChange={onChange} />}
      </Footer>
    );
  },
);
